import { grid } from './grid';
import { font } from './font';
import misc from './misc';
import transition from './transition';
import { zIndex } from './zIndex';
import * as colors from './colors';
import * as content from './content';

export const theme = {
  ...grid,
  ...font,
  ...colors,
  ...content,
  misc,
  transition,
  zIndex,
};

export type Theme = typeof theme;
